<!--赖传峰-->
<!--2023/4/6-->
<template>
  <header
    v-if="visible"
    class="header"
  >
    <a
      class="open-sidebar"
      @click="layoutStore.sidebarMobileVisible = true"
    />
    <a
      :href="RoutePathOfDrive.ALL"
      class="logo"
    />
    <div class="login-entry-placeholder">
      <ClientOnly>
        <a
          v-if="!userInfoStore.userId"
          class="login-icon"
          @click="() => showLoginDialog?.()"
        />
      </ClientOnly>
    </div>
  </header>
</template>

<script lang="ts" setup>
import { computed, inject, isPikPakClient } from '#imports'
import { useLayout } from '~/store/layout'
import { useUserInfo } from '~/store/userInfo'
import { InjectionKey, RoutePathOfDrive } from '~/types/enum'

const layoutStore = useLayout()
const userInfoStore = useUserInfo()
const showLoginDialog = inject<ShowLoginDialog>(InjectionKey.SHOW_LOGIN_DIALOG)
const visible = computed(() => !isPikPakClient())
</script>

<style lang="less" scoped>
@import 'driveHeader.style';
</style>
